module.exports = __webpack_public_path__ + "media/components/users/integrations/images/click_to_call-ab3aca2153997c19e914b715c08f4bb5.svg";